// extracted by mini-css-extract-plugin
export default {"label":"select_label__263D0"};